/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type VoucherSortOrder = typeof VoucherSortOrder[keyof typeof VoucherSortOrder];


export const VoucherSortOrder = {
  newest: 'newest',
  oldest: 'oldest',
} as const;
